import ProviderManagementPage from './providerManagementPage';

export default ProviderManagementPage;
